import { CommonModule, NgIf } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, RemoveCommandDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { BdState } from '../../../../models/repEditorModels'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-bd-states',
    templateUrl: './rep-editor-bd-states.component.html',
    styleUrls: ['./rep-editor-bd-states.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        DropDownListComponent,
        FormsModule,
        ReactiveFormsModule,
        CommandColumnComponent,
        CellTemplateDirective,
        FocusableDirective,
        EditCommandDirective,
        NgIf,
        RemoveCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        AdminOnlyDirective
    ]
})
export class RepEditorBdStatesComponent
  extends GridEditorBaseComponent
  implements OnChanges, AfterViewInit
{
  public activeStateList = this.repState.getActiveStateList()
@Input() override repId: number = 0
  public currentRepId: number
  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    protected cd: ChangeDetectorRef,
    repEditorStateService: RepEditorStateService,
    private route: ActivatedRoute,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
    this.activeStateList = this.repState.getActiveStateList()
    this.route.queryParams.subscribe((params) => {
      if (params['repId']) {
        this.repId = Number(params['repId'])
        //  alert(JSON.stringify(this.repId))
      }
    })
  }

  ngOnChanges() {
    this.activeStateList = this.repState.getActiveStateList()
    this.checkGridState()
  }
  ngAfterViewInit(): void {
    this.checkGridState()

    if (!this.repState.repBdStates) {
      this.initGrid()
    }

    if (!this.repState.stateList) {
      this.typesService.getActiveTypeStatelist().subscribe((response) => {
        this.repState.stateList = response
      })
    }
    this.cd.detectChanges()
  }
  initGrid(): void {
    this.clientService
      .getBdStatesForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repBdStates = response
          .map((rbs) => new BdState(rbs))
          .sort((a, b) => (a.stateText || '').localeCompare(b.stateText || ''))
      })
  }

  public addHandler({ sender }) {
    const newBdState = new BdState(null)
    newBdState.repId = this.repId
    newBdState.active = true
    this.addHandlerShared({ sender }, newBdState)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const bdState = new BdState(formGroup.value)
    bdState.repId = this.repId
    this.clientService.submitBdStateUpdate(bdState).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  public removeHandler({ dataItem }) {
    const itemToRemove = new BdState(dataItem)
    itemToRemove.active = false
    this.clientService.removeBdStateUpdate(itemToRemove).subscribe(() => {
      this.initGrid()
    })
  }

  public createFormGroup(bdState: BdState): UntypedFormGroup {
    return this.formBuilder.group({
      active: bdState.active,
      bdfees: bdState.bdfees,
      repBDStateID: bdState.repBDStateID,
      repId: bdState.repId,
      state: [bdState.state, Validators.required],
      stateText: bdState.stateText,
    })
  }
}
